module.exports = __webpack_public_path__ + "img/8.1.80f264a2.jpg";